import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { BentoProvider } from "@buildo/bento-design-system";
import { defaultMessages } from "@buildo/bento-design-system/defaultMessages/en";
import "@buildo/bento-design-system/index.css";
import "@buildo/bento-design-system/defaultTheme.css";
import "./theme/bentolio.css";
import "./theme/admin.css";
import App from "./App";
import client from "./apolloClient";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BentoProvider defaultMessages={defaultMessages}>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </BentoProvider>
  </React.StrictMode>
);
